module.exports = __webpack_public_path__ + "img/SAFo_StrongPasswords_MFA-Tilt.4236d891.svg";